export const _getTodayDate = () => {
    const today = new Date();
    const yyyy = String(today.getFullYear());
    const mm = String(today.getMonth() + 1).padStart(2, '0'); 
    const dd = String(today.getDate()).padStart(2, '0');
    return `${dd}-${mm}-${yyyy}`;
    // return `${yyyy}-${mm}-${dd}`;
  };
  export const _getTodayDatex = (x) => {
    const today = new Date(x);
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); 
    const dd = String(today.getDate()).padStart(2, '0');
    return `${dd}-${mm}-${yyyy}`;
    //return `${yyyy}-${mm}-${dd}`;
  };
  export const _getDateToISO = (dateStr) => {
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  };
  
  export const _formatAmount = (value) => {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
  
    if (isNaN(numberValue)) {
      return "0.00";
    }
  
    return new Intl.NumberFormat('en-US', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numberValue);
  };
  

  export const _formatDate = (dateInput) => {
    if (!dateInput) return ""; // null, "", undefined case
    
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return ""; // invalid date check
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 01-12
    const day = String(date.getDate()).padStart(2, "0");       // 01-31
  
    return `${year}-${month}-${day}`;
  };
  
  //loader
  
  export const Loader = () => (
    <div className="spinner-border text-info" role="status"></div>
  );
  
  //Style For React_select
  export const customStyleMd = {
    control: (provided, state) => ({
      ...provided,
      fontSize: '14px',
      color: 'black',
      minHeight: '43px',
      fontWeight: 400,
      borderColor: state.isFocused ? '#2c639d' : '#ccc',
      borderRadius: '6px',
      boxShadow: state.isFocused ? '0 0 0 0.1px #2c639d' : null,
      '&:hover': {
        borderColor: '#2c639d',
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#bdbebfbd',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '14px',
      color: '#000000', 
    }),
    option: (provided, state) => ({
      ...provided,
      width:'96%',
      fontSize: '14px',
      color: state.isSelected ? '#000000' : '#000000',
      backgroundColor: state.isSelected ? '#f2f9fc' : 'white',
      ':hover': {
        backgroundColor: state.isSelected ? '' : '#f2f9fc',
      },
      margin:'0px 5px',
      padding:'5px'
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  export const customStyleSm = {
    control: (provided, state) => ({
      ...provided,
      fontSize: '0.775rem', 
      color: 'black',
      height: '28px', 
      minHeight: '28px',
      fontWeight: 400,
      borderColor: state.isFocused ? '#2c639d' : '#ccc',
      borderRadius: '0.2rem', 
      boxShadow: state.isFocused ? '0 0 0 0.1px #2c639d' : null,
      '&:hover': {
        borderColor: '#2c639d',
      },
      display: 'flex',
      alignItems: 'center', 
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '0.775rem', 
      color: '#bdbebfbd',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: '0.775rem', 
      color: '#000000', 
    }),
    input: (provided) => ({
      ...provided,
      fontSize: '0.775rem',
      padding: '0px', 
      margin: '0px',
      height: '28px',
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '28px',
      padding: '0 8px', 
      display: 'flex',
      alignItems: 'center',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '28px', 
    }),
    option: (provided, state) => ({
      ...provided,
      width:'96%',
      fontSize: '0.775rem', 
      padding: '4px 8px', 
      color: state.isSelected ? '#000000' : '#000000',
      backgroundColor: state.isSelected ? '#f2f9fc' : 'white',
      ':hover': {
        backgroundColor: state.isSelected ? '' : '#f2f9fc',
      },
      margin: '0px 5px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  
  //Displaying Amnount in Words
  const numberToWords = (number) => {
    const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const thousands = ["", "Thousand", "Million", "Billion", "Trillion"];
  
    if (number === 0) return "Zero";
  
    let words = "";
  
    const addSpace = (str) => (str ? str + " " : "");
  
    const numberToWordsHelper = (num) => {
      if (num < 10) return units[num];
      if (num < 20) return teens[num - 10];
      if (num < 100) return addSpace(tens[Math.floor(num / 10)]) + units[num % 10];
      if (num < 1000) return addSpace(units[Math.floor(num / 100)]) + "Hundred " + numberToWordsHelper(num % 100);
      for (let i = thousands.length - 1; i >= 0; i--) {
        const unit = Math.pow(1000, i);
        if (num >= unit) {
          return addSpace(numberToWordsHelper(Math.floor(num / unit))) + thousands[i] + " " + numberToWordsHelper(num % unit);
        }
      }
      return "";
    };
  
    words = numberToWordsHelper(number);
  
    return words.trim();
  };
  
  export const convertToRupeesAndPaise = (amount) => {
    const rupees = Math.floor(amount);
    const paise = Math.round((amount - rupees) * 100);
  
    let rupeesInWords = numberToWords(rupees);
    let paiseInWords = paise > 0 ? numberToWords(paise) + " Paisas" : "";
  
    return paiseInWords ? `${rupeesInWords} Rupees and ${paiseInWords} only` : `${rupeesInWords} Rupees only`;
  };

  export const LoginUser = { 
      token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoic2hhcmlmQGdtYWlsLmNvbSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6IlVzZXIiLCJleHAiOjE3NDU5MDQ0NzEsImlzcyI6Imh0dHBzOi8vbG9jYWxob3N0OjcxNTciLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MTU3In0.yFnxS6Rpl4Yxo_MMWcB7CjYLsWFYnpp4zfxWyZ4DJmQ",
      user: {
        id: 1,
        firstName: "Sharif",
        lastName: "Noor",
        userEmail: "sharif@gmail.com",
        userName: "SharifNoor",
        contactNo: "9999999",
        isVerified: true,
        isActive: true,
        lastLogin: "2025-04-25T10:39:37.24",
        loginAttempt: 1,
        isBlocked: true,
        invalidLastLoginAttempt: "2025-04-25T10:39:37.24"
      },
      roles: [
        {
          roleId: 1,
          roleName: "Super Admin",
          pages: [
            { pageId: 1, pageName: "Dashboard", view: true, add: true, edit: true, delete: true, icon: "mdi:view-dashboard", url: "/", parentId: 1, hasChild: false },
            { pageId: 2, pageName: "Vehicles", view: true, add: true, edit: true, delete: true, icon: "mdi:car", url: "/vehicles", parentId: 1, hasChild: false },
            { pageId: 3, pageName: "Cars Parts", view: true, add: true, edit: true, delete: true, icon: "mdi:car-cog", url: "/cars-parts", parentId: 1, hasChild: false },
            { pageId: 4, pageName: "Dealers", view: true, add: true, edit: true, delete: true, icon: "mdi:storefront", url: "/dealers", parentId: 1, hasChild: false },
            { pageId: 5, pageName: "Users", view: true, add: true, edit: true, delete: true, icon: "mdi:account-multiple-outline", url: "/users", parentId: 1, hasChild: false },
            { pageId: 6, pageName: "Test Drives", view: true, add: true, edit: true, delete: true, icon: "mdi:steering", url: "/test-drives", parentId: 1, hasChild: false },
            { pageId: 7, pageName: "Service Appointments", view: true, add: true, edit: true, delete: true, icon: "mdi:calendar-check", url: "/service-appointments", parentId: 1, hasChild: false },
            { pageId: 8, pageName: "Contact Queries", view: true, add: true, edit: true, delete: true, icon: "mdi:account-tie-voice-outline", url: "/contact-us-queries", parentId: 1, hasChild: false },
            { pageId: 9, pageName: "Content Management", view: true, add: true, edit: true, delete: true, icon: "mdi:file-document-outline", url: "/content-mangement", parentId: 1, hasChild: false },
            { pageId: 10, pageName: "Promotions", view: true, add: true, edit: true, delete: true, icon: "mdi:megaphone", url: "/promotions", parentId: 1, hasChild: false },
            { pageId: 11, pageName: "Roles Management", view: true, add: true, edit: true, delete: true, icon: "mdi:alarm-arm-home-outline", url: "/roles-mangement", parentId: 1, hasChild: false }
          ]             
        },
      ],
      "isSuccess": true,
      "isError": false
    }


    export const usama = {
      "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjEiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiY2hhbmdhbkBnbWFpbC5jb20iLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJVc2VyIiwiZXhwIjoxNzUzNjk0MDkyLCJpc3MiOiJZb3VyQXBwSXNzdWVyIiwiYXVkIjoiWW91ckFwcEF1ZGllbmNlIn0.KVNvBi9dAXpvD8CZh0gy7YzxmatYJQYk4oR5yXi8H9g",
      "expiryDate": "2025-07-28",
      "expiryTime": "02:14:52",
      "user": {
          "id": 1,
          "firstName": "Changan",
          "lastName": "MCML",
          "userEmail": "changan@gmail.com",
          "userName": "changanmcml",
          "contactNo": "021111111",
          "isVerified": true,
          "isActive": true,
          "lastLogin": "2025-07-21T05:32:24.283",
          "loginAttempt": 0,
          "isBlocked": true,
          "invalidLastLoginAttempt": "2025-07-21T05:32:24.283"
      },
      "roles": [
          {
              "roleId": 1,
              "roleName": "Super Admin",
              "pages": [
                  {
                      "pageId": 1,
                      "pageName": "Dashboard",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:view-dashboard",
                      "url": "/",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 2,
                      "pageName": "Vehicles",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:car",
                      "url": "/vehicles",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 3,
                      "pageName": "Cars Parts",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:car-cog",
                      "url": "/cars-parts",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 4,
                      "pageName": "Dealers",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:storefront",
                      "url": "/dealers",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 5,
                      "pageName": "Users",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:account-multiple-outline",
                      "url": "/users",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 6,
                      "pageName": "Test Drives",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:steering",
                      "url": "/test-drives",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 7,
                      "pageName": "Service Appointments",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:calendar-check",
                      "url": "/service-appointments",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 8,
                      "pageName": "Contact Queries",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:account-tie-voice-outline",
                      "url": "/contact-us-queries",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 9,
                      "pageName": "Content Management",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:file-document-outline",
                      "url": "/app-settings",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 10,
                      "pageName": "Roles Management",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:alarm-arm-home-outline",
                      "url": "/roles-management",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 11,
                      "pageName": "Promotions",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:megaphone",
                      "url": "/promotions",
                      "parentId": 0,
                      "hasChild": false
                  },
                  {
                      "pageId": 12,
                      "pageName": "Customers",
                      "view": true,
                      "add": true,
                      "edit": true,
                      "delete": true,
                      "icon": "mdi:account-group",
                      "url": "/customers",
                      "parentId": 0,
                      "hasChild": false
                  }
              ]
          }
      ],
      "isSuccess": true,
      "isError": false
  }

 export const menusIcons = [
      { key: 1, title: "About Us", navigateOn:" ", visibleFor: "both", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/AboutUs.png" },
      { key: 2, title: "Add Vehicle", navigateOn:"Chassisbinding", visibleFor: "guest", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/addVehicle.png" },
      { key: 3, title: "Chat", navigateOn:" ", visibleFor: "registered", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/chat.png" },
      { key: 4, title: "Chat Icon", navigateOn:" ", visibleFor: "guest", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/chatIcon.png" },
      { key: 5, title: "Comaplain Registration", navigateOn:"Complain", visibleFor: "both", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/complainRegistration.png" },
      { key: 6, title: "Cost Calculator", navigateOn:"CostCalculator", visibleFor: "guest", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/costCalculator.png" },
      { key: 7, title: "Faqs Icon", navigateOn:" ", visibleFor: "both", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/FaqsIcon.png" },
      { key: 8, title: "Parts", navigateOn:" ", visibleFor: "registered", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/genuine-parts.png" },
      { key: 9, title: "Inquiry", navigateOn:"Inquiry", visibleFor: "both", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/inquiry.png" },
      { key: 11, title: "Manual", navigateOn:" ", visibleFor: "guest", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/manual.png" },
      { key: 12, title: "Manual Icon", navigateOn:" ", visibleFor: "guest", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/manualIcon.png" },
      { key: 13, title: "Map", navigateOn:" ", visibleFor: "registered", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/mapBg.png" },
      { key: 14, title: "Map Icon", navigateOn:"FindDealerLocation", visibleFor: "registered", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/mapIcon.png" },
      { key: 15, title: "Appointment Icon", navigateOn:"AppointmentList", visibleFor: "both", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/myAppointment.png" },
      { key: 16, title: "Genuine Parts", navigateOn:"PartListing", visibleFor: "both", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/PartsListing.png" },
      { key: 17, title: "Parts Listing", navigateOn:" ", visibleFor: "guest", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/partsListingIcon.png" },
      { key: 18, title: "Privacy Policy", navigateOn:" ", visibleFor: "registered", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/privacyPolicy.png" },
      { key: 19, title: "Service History", navigateOn:"ServiceHistory", visibleFor: "both", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/serviceHistory.png" },
      { key: 20, title: "Test Drive", navigateOn:" ", visibleFor: "guest", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/testDrive.png" },
      { key: 21, title: "Test Drive Icon", navigateOn:"BookTestDrive", visibleFor: "both", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/TestDriveIcon.png" },
      { key: 22, title: "Update Password", navigateOn:" ", visibleFor: "registered", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/updatePassword.png" },
      { key: 23, title: "Request Qoute Icon", navigateOn:" ", visibleFor: "guest", imageUrl: "https://changanuat.deepdms.net/Uploads/MenuItems/RequestQouteIcon.png" },
  ]